import { Observable } from 'rxjs/Observable';
// import { AuthService } from './../services/auth.service';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Role } from './role.model';
import { Injectable } from '@angular/core';
import * as myGlobals from './../global';
import * as $ from 'jquery';
// import { catchError } from 'rxjs/operators';
// import { stringify } from '@angular/core/src/render3/util';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  formData: Role;
  list: Role[];

  private _roleUrl = myGlobals.baseApi + '/webadmin/v1/roles';
  private _addRoleUrl = myGlobals.baseApi + '/webadmin/v1/role';
  private _editRoleUrl = myGlobals.baseApi + '/webadmin/v1/role/';
  private _getRoleUrl = myGlobals.baseApi + '/webadmin/v1/role/';

  constructor(private http: HttpClientSecured) {}

  addRole(formData: Role): Observable<any> {
    return this.http.post<any>(this._addRoleUrl, formData);
  }

  allRoles(): Observable<Role[]> {
    console.log('RoleService: allRoles: Incoming method...');
    // console.log('sessionToken: ', localStorage.getItem('sessionToken'));
    return this.http.get<any>(this._roleUrl);
  }
}
